import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Stack } from '@/components/layout';
import { AppHeader } from '@/components/layout/app-header';
import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { useNavigation } from '@react-navigation/native';

export const MutatePlayerHeader = ({
  title,
  onDelete,
  isBoldTitle = false,
}: {
  title?: string;
  onDelete?: () => void;
  isBoldTitle?: boolean;
}) => {
  const { scale, isTablet } = useScaling();
  const navigation = useNavigation();
  const styles = useStyles();

  return (
    <AppHeader backgroundColor={colors['0']}>
      <AppHeader.Left>
        <TouchableOpacity activeOpacity={0.6} onPress={() => navigation.goBack()}>
          <Stack direction="row" align="center" gap={scale(2)}>
            <SvgIcon name="IcBackBlue" size={scale(24)} />
            <Text
              variant={isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Medium'}
              style={styles.headerActionText}>
              {STRINGS.player.mutatePlayer.header.back}
            </Text>
          </Stack>
        </TouchableOpacity>
      </AppHeader.Left>

      <AppHeader.Title>
        <Text
          variant={
            isTablet
              ? 'Font Inter/Subtitle/Bold 14px'
              : 'Font Montserrat/Subtitle/Minimize 1 Bold 11px'
          }
          fontWeight={isBoldTitle || isTablet ? undefined : '800'}
          style={styles.headerTitle}>
          {title ?? STRINGS.player.mutatePlayer.header.title}
        </Text>
      </AppHeader.Title>

      <AppHeader.Right>
        {onDelete ? (
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={onDelete}
            style={styles.headerDeleteButton}>
            <Stack direction="row" align="center" gap={scale(4)}>
              <Text
                variant={
                  isTablet ? 'Font Inter/Subtitle/Medium 14px' : 'Font Inter/Subtitle/Medium'
                }
                style={styles.headerDeleteText}>
                {STRINGS.player.mutatePlayer.footer.deletePlayer}
              </Text>
              <SvgIcon name="IcTrash" size={scale(24)} color={colors.Error} />
            </Stack>
          </TouchableOpacity>
        ) : (
          <Stack
            width={scale({ phone: 57, tablet: 60 })}
            height={scale({ phone: 28, tablet: 30 })}
          />
        )}
      </AppHeader.Right>
    </AppHeader>
  );
};

const useStyles = createStyles(() => ({
  headerActionText: {
    color: colors.Blue,
  },
  headerTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  headerDeleteButton: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  headerDeleteText: {
    color: colors.Error,
  },
}));
